import * as Yup from "yup";

export interface EditionFormData {
  editionType: string;
  fopCertificateDate: Date;
  numberOfPages: number;
  contentWrapperHardCopy: File | null;
}

const today = new Date().toISOString().split("T")[0];

var date = Yup.date()
  .typeError("Date  is required")
  .max(new Date(today), "Date cannot be in the future");

var number = Yup.string()
  .typeError("This is required")
  .required("This is required")
  .matches(/^[0-9]+$/, "Must be a number");

var string = Yup.string().required("This is required");
var array_of_string = Yup.array().of(Yup.string()).required("This is required");
var optional = Yup.string().nullable();

// var optional = Yup.string().optional();

//file upload validation
// var document = Yup.string().required("Document is required");
var document = Yup.mixed().required("Document is required");

const statusBaseSchema = {
  name: string,
};

const loopBaseSchema = {
  name: string,
  panel_id: number,
};

const controllerBaseSchema = {
  select: string,
  text_input: string,
  signle_upload: document,
  multiple_upload: document,
  multi_select: array_of_string,
};

const addSensorTypeSchema = {
  name: string,
};
const addRoleBaseSchema = {
  rollName: string,
};
const addLocationBaseSchema = {
  name: optional,
  location_id: optional,
  company_id: optional,
  floor_plan: optional,
};

const addBrandBaseSchema = {
  brandName: string,
};

const panelBaseSchema = {
  name: string,
  gateway_id: optional,
  controller_id: optional,
  // is_panel_attached_with_controller: number
};
const alertBaseSchema = {
  name: string,
  color: string,
};

// Exported function to create validation schema
export const AddRoleSchema = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...addRoleBaseSchema,
    }); // Ensure return type matches EditionFormData
  }

  return Yup.object().shape(addRoleBaseSchema); // Ensure return type matches EditionFormData
};
export const SensorTypeSchema = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...addSensorTypeSchema,
    }); // Ensure return type matches EditionFormData
  }

  return Yup.object().shape(addSensorTypeSchema); // Ensure return type matches EditionFormData
};

export const AddLocationSchema = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...addLocationBaseSchema,
    }); // Ensure return type matches EditionFormData
  }

  return Yup.object().shape(addLocationBaseSchema); // Ensure return type matches EditionFormData
};

const userBaseSchema = {
  username: string,
  name: string,
  mobile_no: string,
  role_id: number,
  branch_id: number,
  email: string,
};
const gatewayBaseSchema = {
  // branch_name: string,
  // brand_name: string,
  // model_name: string,
  gateway_name: string,
  serial_number: number,
  mac_address: string,
  branch_id: number,
  brand_id: number,
  model_id: number,
  notify_seconds: number,
  inactive_status_frequency_seconds: number,
};
const gatewayBaseAddMoreSchema = {
  model_name: string,
};

export const UserRoleSchema = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...userBaseSchema,
    }); // Ensure return type matches EditionFormData
  }

  return Yup.object().shape(userBaseSchema); // Ensure return type matches EditionFormData
};

// Exported function to create validation schema
export const StatusSchema = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...statusBaseSchema,
    }); // Ensure return type matches EditionFormData
  }
  return Yup.object().shape(statusBaseSchema); // Ensure return type matches EditionFormData
};

export const GatewaySchema = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...gatewayBaseSchema,
    }); // Ensure return type matches EditionFormData
  }

  return Yup.object().shape(gatewayBaseSchema); // Ensure return type matches EditionFormData
};


export const LoginSchema = Yup.object().shape({
  username: Yup.string().required("Username is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
  captcha : Yup.string().required("Captha is required")
});
// Gate Way Add More
export const GatewaySchemaAddMore = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...gatewayBaseAddMoreSchema,
    }); // Ensure return type matches EditionFormData
  }

  return Yup.object().shape(gatewayBaseAddMoreSchema); // Ensure return type matches EditionFormData
};

export const AddBrandSchema = Yup.object().shape({
  brandType: string,
  brandName: string,
  models: Yup.array()
    .of(
      Yup.object().shape({
        name: string,
        id: optional,
      })
    )
    .min(1, "At least one Roll Name is required"),
});

export const baseAddSensorSchema = {
  sensorCode: string,
  sensorName: string,
  sensorType: string,
  deviceAddress: string,
  branchId: string,
  locationId: string,
  brandID: string,
  modalID: string,
  // minBitOrderValue: string,
  // maxBitOrderValue: string,
  yesOrNo: string,
};
export const AddSensorSchema = (includeFirstFourFields: number) => {
  if (includeFirstFourFields == 1) {
    return Yup.object().shape({
      ...baseAddSensorSchema,
      panal: string,
      loopID: string,
      gateway: string,
    });
  }
  return Yup.object().shape(baseAddSensorSchema); // Ensure return type matches EditionFormData
};

export const LoopsSchema = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...loopBaseSchema,
    }); // Ensure return type matches EditionFormData
  }

  return Yup.object().shape(loopBaseSchema); // Ensure return type matches EditionFormData
};

export const ControllersSchema = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...controllerBaseSchema,
    }); // Ensure return type matches EditionFor  mData
  }

  return Yup.object().shape(loopBaseSchema); // Ensure return type matches EditionFormData
};

export const AlertTypesSchema = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...alertBaseSchema,
    }); // Ensure return type matches EditionFormData
  }

  return Yup.object().shape(loopBaseSchema); // Ensure return type matches EditionFormData
};

export const PanelSchema = (includeFirstFourFields: boolean) => {
  if (includeFirstFourFields) {
    return Yup.object().shape({
      ...panelBaseSchema,
      branchId: string,
      locationId: string,
      brandID: string,
      modalID: string,
    }); // Ensure return type matches EditionFormData
  }

  return Yup.object().shape(panelBaseSchema); // Ensure return type matches EditionFormData
};

export const AddStatusCodeSchema = Yup.object().shape({
  status_codes: Yup.array()
    .of(
      Yup.object().shape({
        status_code_type_id: string,
        code: string,
        status_id: string,
        alert_type_id: string,
        id: optional,
      })
    )
    .min(1, "At least one Status Code is required"),
});



export const DistrictDetailsSchema = Yup.object().shape({
  district: Yup.array().of(Yup.string()).required("This is required"),
});